module.exports = __webpack_public_path__ + "static/images/c441718e2b867eae3b7902544a70e711.webp";